<template>
    <div v-bind:class="[resultClass]">
        <div class="panel-heading" v-if="title || forceHeader">
            <h3 class="panel-title" v-if="title">{{ title }}</h3>
            <div v-if="hasHeader" class="heading-elements" :class="{'full-width has-icon-left': !title}">
                <slot name="headingElements"></slot>
            </div>
        </div>
        <div class="panel-body">
            <slot></slot>
        </div>

        <div class="panel-footer" v-show="footerShow && hasFooter">
            <div class="heading-elements">
                <slot name="footerElements"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'panel',
  props: [ 'cssClass', 'title', 'footerShow', 'forceHeader' ],

  data () {
    return {}
  },

  created () {
    this.resultClass = this.cssClass || 'panel panel-flat'
  },
  methods: {},

  computed: {
    hasFooter: function () {
      return this.$slots.footerElements
    },
    hasHeader: function () {
      return this.$slots.headingElements
    }
  },

  mounted () {
    // Add control button toggler to page and panel headers if have heading elements
    // eslint-disable-next-line
    $('.panel-footer').has('> .heading-elements:not(.not-collapsible)').each(function (el, index) {
      // eslint-disable-next-line
      if (!$(el).has('> .heading-elements-toggle')) {
        // eslint-disable-next-line
        $(el).prepend('<a class="heading-elements-toggle"><i class="icon-more"></i></a>')
      }
    })
    // eslint-disable-next-line
    $('.page-title, .panel-title').parent().has('> .heading-elements:not(.not-collapsible)').children('.page-title, .panel-title').append('<a class="heading-elements-toggle"><i class="icon-more"></i></a>')

    // Toggle visible state of heading elements
    // eslint-disable-next-line
    $('.page-title .heading-elements-toggle, .panel-title .heading-elements-toggle').on('click', function () {
      // eslint-disable-next-line
      $(this).parent().parent().toggleClass('has-visible-elements').children('.heading-elements').toggleClass('visible-elements')
    })
    // eslint-disable-next-line
    $('.panel-footer .heading-elements-toggle').on('click', function () {
      // eslint-disable-next-line
      $(this).parent().toggleClass('has-visible-elements').children('.heading-elements').toggleClass('visible-elements')
    })
  }
}
</script>

<style scoped>

</style>
